import { FC, useMemo } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import './PartnersUploadProgress.scss';

export type PartnersUploadProgressState = {
  total: number;
  processed: number;
  created: number;
  skipped: number;
  failed: number;
};

type Props = PartnersUploadProgressState;

const PartnersUploadProgress: FC<Props> = ({
  total,
  processed,
  created,
  skipped,
  failed,
}) => {
  const { t } = useTranslate();

  const percentage = useMemo(() => {
    if (!total) {
      return 0;
    }

    return Math.min(100, Math.round((processed / total) * 100));
  }, [processed, total]);

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">{t('PartnersBulkUploadInProgress')}</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="partners-upload-progress">
          <p className="text-soft mb-4">{t('PartnersBulkUploadDoNotClose')}</p>
          <h2 className="partners-upload-progress-percentage">{percentage}%</h2>
          <div className="progress progress-lg bg-light rounded">
            <div
              className={`progress-bar progress-bar-striped progress-bar-animated ${
                percentage === 100 ? 'bg-success' : 'bg-primary'
              }`}
              data-progress={percentage}
              style={{ width: `${percentage}%` }}
            />
          </div>
          <p className="mt-3 mb-4">
            {t('PartnersBulkUploadProgressCount', { processed, total })}
          </p>
          <ul className="partners-upload-progress-stats list-unstyled mb-0">
            <li>
              {t('PartnersBulkUploadCreatedCount', { count: created })}
            </li>
            <li>
              {t('PartnersBulkUploadSkippedCount', { count: skipped })}
            </li>
            <li>{t('PartnersBulkUploadFailedCount', { count: failed })}</li>
          </ul>
        </div>
      </Modal.Body>
    </>
  );
};

export default PartnersUploadProgress;
